import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background: linear-gradient(180deg, #F5FFFB 1.9225rem, #FFFFFF calc(15/100 * 100vh));
    overflow-x: hidden;
    min-height: 100vh;
    margin: 0 auto;
    background-repeat: no-repeat;
  }

  body, button, input, textarea {
    font-family: 'Nunito', sans-serif;
  }
`;
